/* ==========================================================================
   HEXA - Colour Temperature info modal
   Opens an in-page modal from the (i) button next to the Colour Temperature
   option. Vanilla JS, no dependencies. Handles multiple instances per page.
   ========================================================================== */
(function () {
  'use strict';

  var OPEN_CLASS = 'is-open';
  var lastFocused = null;

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openModal(modal, trigger) {
    if (!modal) return;
    lastFocused = trigger || document.activeElement;
    modal.hidden = false;
    // Force reflow so the CSS transition runs from the hidden state.
    void modal.offsetWidth;
    modal.classList.add(OPEN_CLASS);
    lockScroll(true);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var closeBtn = modal.querySelector('[data-hx-cctm-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal || !modal.classList.contains(OPEN_CLASS)) return;
    modal.classList.remove(OPEN_CLASS);
    lockScroll(false);
    var trigger = document.querySelector('[data-hx-cctm-open][aria-controls="' + modal.id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    // Hide after the transition ends so it stays out of the tab order.
    window.setTimeout(function () {
      if (!modal.classList.contains(OPEN_CLASS)) modal.hidden = true;
    }, 300);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest ? e.target.closest('[data-hx-cctm-open]') : null;
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      var id = openBtn.getAttribute('aria-controls');
      openModal(document.getElementById(id), openBtn);
      return;
    }

    var closeBtn = e.target.closest ? e.target.closest('[data-hx-cctm-close]') : null;
    if (closeBtn) {
      e.preventDefault();
      closeModal(closeBtn.closest('.hx-cctm'));
      return;
    }

    // Backdrop click (the overlay itself, not the panel).
    if (e.target.classList && e.target.classList.contains('hx-cctm')) {
      closeModal(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      var open = document.querySelector('.hx-cctm.' + OPEN_CLASS);
      if (open) closeModal(open);
    }
  });
})();
